export const reportAccessibility = async (App) => {
  if (process.env.REACT_APP_ENV === "local" && typeof window !== "undefined") {
    console.warn('Initializing axe-core');
    const axe = await import("@axe-core/react");
    const ReactDOM = await import("react-dom");

    axe.default(App, ReactDOM, 1000);
  }
};

export default reportAccessibility;
